<template>
  <div class="activity-risk-category">
    <v-row no-gutters class="search-container align-center pb-6">
      <v-col cols="4">
        <v-select
          id="selectedActivityType"
          v-model="selectedActivityType"
          class="excursion-selection"
          :items="listActivityTypes"
          item-title="name"
          item-value="name"
          label="Select an Activity Type"
          testing-id="selected-activity-type"
          variant="solo"
          density="compact"
          color="primary"
          single-line
          hide-details
          return-object
          clearable
          clear-icon="mdi-close"
          :disabled="!formControlEnabled"
          @update:model-value="resetSelectedClass"
        >
          <template #item="data">
            <v-list-item
              v-bind="data.props"
              :id="`activity-risk-category--activity-type--option-${String(
                data.props.title
              ).replaceAll(' ', '')}`"
            >
              {{ data.item.name }}
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col cols="1" class="d-flex justify-center ma-0">
        <v-icon size="large">mdi-chevron-right</v-icon>
      </v-col>
      <v-col cols="4">
        <v-select
          id="activity-risk-category--activity-class--selection"
          v-model="selectedActivityClass"
          class="excursion-selection"
          :items="listActivityClasses"
          item-title="name"
          item-value="name"
          :label="placeholderActivityRiskClass"
          variant="solo"
          color="primary"
          density="compact"
          hide-details
          single-line
          clearable
          return-object
          clear-icon="mdi-close"
          :disabled="!formControlEnabled"
          :menu-props="{
            maxHeight: 400
          }"
        >
          <template #item="data">
            <v-list-item
              v-bind="data.props"
              :id="`activity-risk-category--activity-class--option-${String(
                data.item.title
              ).replaceAll(' ', '')}`"
            >
              {{ data.item.name }}
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <select
      id="selectActivityRisk"
      class="js-example-basic-single excursion-selection safe-select2-dropdown"
      name="selectActivityRisk"
      :disabled="!formControlEnabled"
      aria-labelledby="selectActivityRisk"
    >
      <option value></option>
      <optgroup
        v-for="(riskClass, cindex) in filterActivityRisks(
          selectedActivityType,
          selectedActivityClass
        )"
        :key="cindex"
        :label="riskClass.name"
      >
        <option
          v-for="(risk, rindex) in riskClass.risks"
          :key="rindex"
          :value="risk.name"
          :title="riskClass.name + ',' + riskClass.typeName"
          :disabled="risk.disabled"
        >
          {{ risk.name }}
        </option>
      </optgroup>
    </select>
    <div v-if="0 < selectedActivityClasses.length" class="activity-category-class">
      <div v-for="(riskType, tindex) in selectedActivityClasses[0].types" :key="tindex">
        <div
          v-for="riskClass in riskType.classes"
          :key="setKey(riskClass)"
          class="sub-category-section"
        >
          <v-row no-gutters class="align-center">
            <v-col>
              <div class="name">{{ riskClass.name }}</div>
            </v-col>
            <v-col v-if="checklistAndPolicyDisplayed" class="d-flex justify-end">
              <complete-checklist
                ref="completeChecklist"
                :category-name="selectedActivityClasses[0].name"
                :risk-type-name="riskType.name"
                :risk-class-name="riskClass.name"
                :associated-checklist-completed="getTicked(riskClass)"
                :form-control-enabled="formControlEnabled"
                :element-disabled="
                  (riskClass.risks &&
                    elementDisabled &&
                    riskType.name === checklistFetchActionRiskTypeName &&
                    riskClass.name === checklistFetchActionRiskClassName) ||
                  !riskClass.risks
                "
                :checklist-fetch-action-category-name="selectedActivityClasses[0].name"
                :checklist-fetch-action-risk-type-name="checklistFetchActionRiskTypeName"
                :checklist-fetch-action-risk-class-name="checklistFetchActionRiskClassName"
                :checklist-fetch-action-in-progress="checklistFetchActionInProgress"
                :save-draft="saveDraft"
              />
              <view-policy
                :category-name="selectedActivityClasses[0].name"
                :risk-type-name="riskType.name"
                :risk-class-name="riskClass.name"
                :element-disabled="!riskClass.risks"
                :activity-supervisor-scroll-displayed="true"
              />
            </v-col>
          </v-row>
          <div v-if="!riskClass.risks">
            <v-row>
              <v-col cols="11">
                <v-select
                  id="changeActivityPreSelectedRisk"
                  class="type-dropdown risk-class-select excursion-selection empty-risk-selection"
                  :items="listActivityRisks('', riskClass.name, riskType.name)"
                  :item-props="listActivityRisksProps"
                  item-disabled="disabled"
                  color="primary"
                  variant="solo"
                  density="compact"
                  testing-id="list-risk"
                  placeholder="Select a risk"
                  hide-details
                  @update:model-value="
                    changeActivitySelectedRiskId(riskClass.name, riskType.name, {}, $event)
                  "
                >
                  <template #item="data">
                    <v-list-item
                      v-bind="data.props"
                      :id="`activity-risk-category--activity-selected-risk--option-${String(
                        data.item.name
                      ).replaceAll(' ', '')}`"
                      :disabled="data.props.disabled"
                      active-class="active-risk-category-activity"
                    >
                      {{ data.item.name }}
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="1" class="justify-center">
                <div>
                  <v-icon
                    :id="getActivityRiskDeleteId(riskType, riskClass, null)"
                    :disabled="!formControlEnabled"
                    size="large"
                    @click="displayDeleteRiskConfirm(riskType, riskClass, null)"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </div>
          <div v-if="riskClass.risks && 0 < riskClass.risks.length">
            <v-row v-for="(selectedRisk, index) in riskClass.risks" :key="index" dense>
              <v-col cols="11">
                <v-select
                  :id="getActivityRiskId(riskType, riskClass, selectedRisk)"
                  class="type-dropdown risk-class-select excursion-selection"
                  :items="listActivityRisks(selectedRisk.name, riskClass.name, riskType.name)"
                  :item-props="listActivityRisksProps"
                  color="primary"
                  variant="solo"
                  density="compact"
                  hide-details
                  :model-value="selectedRisk.name"
                  testing-id="list-risk"
                  :disabled="!formControlEnabled"
                  @update:model-value="
                    changeActivitySelectedRiskId(
                      riskClass.name,
                      riskType.name,
                      selectedRisk,
                      $event
                    )
                  "
                >
                  <template #item="data">
                    <v-list-item
                      v-bind="data.props"
                      :id="`activity-risk-category--activity-selected-risk--option-${String(
                        data.item.name
                      ).replaceAll(' ', '')}`"
                      :disabled="data.props.disabled"
                      active-class="active-risk-category-activity"
                    >
                      {{ data.item.name }}
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="1" class="d-flex justify-center">
                <v-icon
                  :id="getActivityRiskDeleteId(riskType, riskClass, selectedRisk)"
                  :disabled="!formControlEnabled"
                  size="large"
                  @click="displayDeleteRiskConfirm(riskType, riskClass, selectedRisk)"
                >
                  mdi-delete
                </v-icon>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </div>
    <cs-form-dialog
      id="dlg-activity-risk-category"
      v-model="deleteActivityRiskDisplayed"
      body-id="dlg-body-activity-risk-category"
      heading="Delete Risk Category Type"
      :primary-action="{
        label: 'Delete',
        eventName: 'primary-click'
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="removeActivitySelectedRiskId"
      @secondary1-click="deleteActivityRiskDisplayed = false"
      @update:model-value="deleteActivityRiskDisplayed = false"
    >
      <template #cs-form-dialog-content>Are you sure?</template>
    </cs-form-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import riskCategoryLabel from '../lib/const/riskCategoryLabel';
import CompleteChecklist from './CompleteChecklist';

export default {
  name: 'ActivityRiskCategory',
  components: {
    CompleteChecklist
  },
  props: {
    formControlEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    checklistAndPolicyDisplayed: Boolean,
    saveDraft: {
      type: Function,
      default: () => {}
    }
  },
  emits: ['changeActivityDone'],
  data() {
    return {
      checklistFetchActionRiskTypeName: '',
      checklistFetchActionRiskClassName: '',
      checklistFetchActionInProgress: false,
      checklistFetchActionCount: 0,
      checklistFetchActionDoneCount: 0,
      elementDisabled: true,
      currentSelectedType: {},
      currentSelectedClass: {},
      currentSelectedRisk: {},
      deleteActivityRiskDisplayed: false
    };
  },
  computed: {
    selectedActivityType: {
      get() {
        return this.$store.state.common.selectedActivityTypeFilter;
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_SELECTED_ACTIVITY_TYPE_FILTER, value);
      }
    },
    selectedActivityClass: {
      get() {
        return this.$store.state.common.selectedActivityClassFilter;
      },
      set(value) {
        this.$store.commit(types.COMMON_SET_SELECTED_ACTIVITY_CLASS_FILTER, value);
      }
    },
    allActivityRisks() {
      return this.$store.getters['common/getAllActivityRisks'];
    },
    filterActivityRisks() {
      return (type, riskClass) => {
        const typeName = type ? type.name : '';
        const className = riskClass ? riskClass.name : '';
        return this.$store.getters['common/getActivityRisksByClass'](typeName, className);
      };
    },
    selectedActivityClasses() {
      return this.$store.getters['common/getSelectedActivityClasses'];
    },
    listActivityClasses() {
      let selectActivityName = '';
      if (this.selectedActivityType) {
        selectActivityName = this.selectedActivityType.name;
      }
      return this.allActivityRisks.filter((r) => r.typeName === selectActivityName);
    },
    listActivityTypes() {
      return this.$store.getters['common/getAllActivityTypes'];
    },
    placeholderActivityRiskClass() {
      const activityType = this.$store.state.common.selectedActivityTypeFilter;
      if (activityType && activityType.name !== '') {
        return `Select ${activityType.name} Type`;
      }

      return '';
    }
  },
  mounted() {
    const store = this.$store;
    const that = this;
    // eslint-disable-next-line no-undef
    const $selector = $('#selectActivityRisk');
    if (
      typeof $selector.data('select2') === 'undefined' &&
      $selector.next().hasClass('select2-container')
    ) {
      $selector.select2('destroy');
    }

    $selector.select2({
      matcher: this.$app.selectCustom.matchCustom,
      width: 'resolve',
      placeholder: 'Add Activity Type'
    });

    $selector.on('select2:select', (e) => {
      const risk = {
        // eslint-disable-next-line no-underscore-dangle
        name: e.params.data.element._value
      };
      const riskClassName = e.params.data.title;
      // eslint-disable-next-line no-undef
      $('#selectActivityRisk').val('');
      // eslint-disable-next-line no-undef
      $('#selectActivityRisk').trigger('change.select2');

      store.dispatch('common/changeActivitySelectRisk', {
        risk,
        riskClassName
      });

      const typeName = riskClassName.split(',')[1];
      const className = riskClassName.split(',')[0];
      that.changeActivityRiskClassChecklist(typeName, className);
      that.$emit('changeActivityDone');
    });

    // eslint-disable-next-line no-undef
    $('.v-input').on('click', () => {
      $selector.select2('close');
    });
  },
  updated() {
    // eslint-disable-next-line no-undef
    const $selector = $('#selectActivityRisk');
    if (
      typeof $selector.data('select2') === 'undefined' &&
      $selector.next().hasClass('select2-container')
    ) {
      $selector.next().remove();
    }

    let placeHolder = 'Add Activity Type';
    if (
      this.selectedActivityType &&
      this.selectedActivityClass &&
      typeof this.selectedActivityType !== 'undefined' &&
      typeof this.selectedActivityClass !== 'undefined' &&
      this.selectedActivityType.name !== '' &&
      this.selectedActivityClass.name !== ''
    ) {
      placeHolder = `Select ${this.selectedActivityClass.name} Type`;
    }
    $selector.select2({
      matcher: this.$app.selectCustom.matchCustom,
      width: 'resolve',
      placeholder: placeHolder
    });
  },
  unmounted() {
    // eslint-disable-next-line no-undef
    const $selector = $(`#selectActivityRisk`);
    $selector.select2('destroy');
  },
  methods: {
    listActivityRisks(selectedRiskName, riskClassName, riskTypeName) {
      let risks;
      const riskClass = this.allActivityRisks.find(
        (r) => r.name === riskClassName && r.typeName === riskTypeName
      );
      if (!riskClass || !riskClass.risks) {
        risks = [];
      } else {
        risks = riskClass.risks;
      }

      if (selectedRiskName) {
        if (risks.findIndex((r) => r.name === selectedRiskName) === -1) {
          return [{ name: selectedRiskName }];
        }
      }

      // Prevent "Complete Checklist" button from being disabled when the activity risk loads
      if (!this.checklistFetchActionInProgress) {
        this.elementDisabled = false;
      }

      return risks;
    },
    listActivityRisksProps(item) {
      return {
        title: item.name,
        value: item.name,
        disabled: item.disabled
      };
    },
    getActivityRiskFromAllRisks(className, typeName, selectedRisk) {
      const riskClass = this.allActivityRisks.find(
        (c) => c.name === className && c.typeName === typeName
      );
      if (riskClass && riskClass.risks) {
        return riskClass.risks.find((r) => r.name === selectedRisk);
      }

      return undefined;
    },
    changeActivitySelectedRiskId(className, typeName, selectedRisk, event) {
      const localSelectedRisk = selectedRisk;
      const currentSelected = this.getActivityRiskFromAllRisks(className, typeName, event);

      if (localSelectedRisk.name) {
        this.$store.dispatch('common/setRiskClassRiskDisabled', {
          categoryName: riskCategoryLabel.ACTIVITIES,
          typeName,
          className,
          riskName: localSelectedRisk.name,
          disabled: false
        });
      }
      this.$store.dispatch('common/setExcursionSelectedCategoryTypeClassRisk', {
        categoryName: riskCategoryLabel.ACTIVITIES,
        typeName,
        className,
        oldRiskName: localSelectedRisk.name,
        newRiskName: currentSelected.name
      });

      this.$store.dispatch('common/setRiskClassRiskDisabled', {
        categoryName: riskCategoryLabel.ACTIVITIES,
        typeName,
        className,
        riskName: event,
        disabled: true
      });

      this.changeActivityRiskClassChecklist(typeName, className);
      this.$store.dispatch('common/setActivitySelectionValid');
      this.$emit('changeActivityDone');
    },
    removeActivitySelectedRiskId() {
      const typeName = this.currentSelectedType.name;
      const className = this.currentSelectedClass.name;

      if (!this.currentSelectedRisk) {
        const selectedClasses = this.selectedActivityClasses[0].types.find(
          (t) => t.name === typeName
        ).classes;
        const selectedClass = selectedClasses.find((c) => c.name === className);
        const index = selectedClasses.indexOf(selectedClass);
        selectedClasses.splice(index, 1);
      } else {
        const riskName = this.currentSelectedRisk.name;
        const deleteRisk = this.getActivityRiskFromAllRisks(className, typeName, riskName);
        if (deleteRisk) {
          this.$store.dispatch('common/setRiskClassRiskDisabled', {
            categoryName: riskCategoryLabel.ACTIVITIES,
            typeName,
            className,
            riskName,
            disabled: false
          });
        }

        this.$store.dispatch('common/deleteExcursionSelectedCategoryTypeClassRisk', {
          categoryName: riskCategoryLabel.ACTIVITIES,
          typeName,
          className,
          riskName
        });
        this.changeActivityRiskClassChecklist(typeName, className);
      }

      this.$emit('changeActivityDone');
      this.$store.dispatch('common/setActivitySelectionValid');
      this.currentSelectedType = {};
      this.currentSelectedClass = {};
      this.currentSelectedRisk = {};
      this.deleteActivityRiskDisplayed = false;
      return true;
    },
    resetSelectedClass() {
      this.$store.commit(types.COMMON_SET_SELECTED_ACTIVITY_CLASS_FILTER, null);
    },
    getTicked(item) {
      let allBox = 0;
      let allChecked = 0;
      if (
        item &&
        item.CompleteChecklist &&
        item.CompleteChecklist.length > 0 &&
        item.CompleteChecklist[0].checklist &&
        item.CompleteChecklist[0].checklist.Strategy &&
        item.CompleteChecklist[0].checklist.Strategy.data
      ) {
        const { data } = item.CompleteChecklist[0].checklist.Strategy;
        const dataKey = Object.keys(data);

        if (
          data[dataKey] &&
          data[dataKey].children &&
          data[dataKey].children.length > 0 &&
          data[dataKey].children[0].children
        ) {
          const checklist = data[dataKey].children[0].children;

          if (checklist && checklist.length > 0) {
            checklist.forEach((box) => {
              if (box.children && box.children.length > 0) {
                const boxes = box.children.filter((ck) => {
                  return ck.contentType === 'checkbox';
                });

                if (boxes && boxes.length > 0) {
                  allBox += boxes.length;
                }

                const checked = box.children.filter((ck) => {
                  return ck.ticked && ck.contentType === 'checkbox';
                });

                if (checked && checked.length > 0) {
                  allChecked += checked.length;
                }
              }
            });
          }
        }
      } else {
        allChecked = -1;
      }

      return allBox === allChecked;
    },
    selectedRiskExistInItems(selectedRiskName, riskClassName, riskTypeName) {
      const items = this.listActivityRisks(null, riskClassName, riskTypeName);
      if (items.findIndex((i) => i.name === selectedRiskName) > -1) {
        return true;
      }
      return false;
    },
    changeActivityRiskClassChecklist(riskTypeName, riskClassName) {
      const risk = this.$store.getters['common/getActivityRiskClass'](riskTypeName, riskClassName);
      const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
        store: this.$store,
        app: this.$app
      });
      const allParams = excursionCommonAdapter.getActivityParams();

      const params = allParams.filter((p) => p.indexOf(riskClassName) >= 0);
      const queryParam = this.$route.query;
      this.checklistFetchActionRiskTypeName = riskTypeName;
      this.checklistFetchActionRiskClassName = riskClassName;
      this.checklistFetchActionInProgress = true;
      this.$store.commit(types.COMMON_SET_CHECKLIST_FETCH_ACTION_IN_PROGRESS, true);
      this.elementDisabled = true;
      this.checklistFetchActionCount += 1;
      const that = this;
      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        store: this.$store,
        queryParam,
        params,
        risk,
        resolve() {
          that.checklistFetchActionDoneCount += 1;
          if (that.checklistFetchActionCount === that.checklistFetchActionDoneCount) {
            that.checklistFetchActionInProgress = false;
            that.$store.commit(types.COMMON_SET_CHECKLIST_FETCH_ACTION_IN_PROGRESS, false);
            that.elementDisabled = false;
            that.checklistFetchActionCount = 0;
            that.checklistFetchActionDoneCount = 0;
          }
        }
      };

      this.$store.dispatch('common/changeActivityRiskCategoryCompleteChecklist', argHash);

      if (this.$refs.completeChecklist) {
        const currentButtons = this.$refs.completeChecklist.filter(
          (c) => c.completeChecklistBtnId === `btnChecklist${riskTypeName}${riskClassName}`
        );
        if (currentButtons && currentButtons.length > 0) {
          currentButtons[0].resetCompleteButton();
        }
      }
    },
    displayDeleteRiskConfirm(riskType, riskClass, risk) {
      this.deleteActivityRiskDisplayed = true;
      this.currentSelectedType = riskType;
      this.currentSelectedClass = riskClass;
      this.currentSelectedRisk = risk;
    },
    setKey(riskClass) {
      return riskClass.name.replace(/\s*/g, '');
    },
    getActivityRiskId(riskType, riskClass, selectedRisk) {
      const riskTypeId = riskType.name.replace(/\s*/g, '');
      const riskClassId = riskClass.name.replace(/\s*/g, '');
      const riskId = selectedRisk.name.replace(/\s*/g, '');
      return `activity-risk--${riskTypeId}-${riskClassId}-${riskId}`;
    },
    getActivityRiskDeleteId(riskType, riskClass, selectedRisk) {
      const riskTypeId = riskType.name.replace(/\s*/g, '');
      const riskClassId = riskClass.name.replace(/\s*/g, '');
      const riskId = selectedRisk ? `-${selectedRisk.name.replace(/\s*/g, '')}` : '';
      return `activity-risk--btn-delete-${riskTypeId}-${riskClassId}${riskId}`;
    }
  }
};
</script>

<style scoped>
:deep(.search-container .mdi-close) {
  color: rgb(var(--v-theme-primary));
}

.sub-category-section {
  color: #818080;
}

.sub-category-section .name {
  font-style: italic;
}

.sub-category-section .section-btn {
  font-size: 0.8em;
}

.active-risk-category-activity :deep(.v-list-item__overlay) {
  background-color: #ffffff;
}

:deep(.select2-container--default .select2-selection--single) {
  background: #eeeeee;
}

:deep(.select2-container .select2-selection--single) {
  height: 42px;
}

.empty-risk-selection :deep(.v-field) {
  box-shadow:
    0px 3px 1px -2px rgb(29, 175, 236),
    0px 2px 2px 0px rgb(29, 175, 236),
    0px 1px 5px 0px rgb(29, 175, 236) !important;
}
</style>
